import { Directive } from 'angular-ts-decorators';
import { FocusManager } from '../../services/focus-manager';

/**
 * Expose on component `type` & `backspace` methods. Both update the current
 * value of 'this.focusManager'.
 *
 * ## Usage example
 * <pre>
 *   <sw-pad>
 *     <button sw-type="1">1</button>
 *     <button sw-type="2">2</button>
 *     <button sw-backspace>C</button>
 *   </sw-pad>
 * </pre>
 */
@Directive({
  restrict: 'E',
  selector: 'swPad',
})
export class SwPadComponent {
  private inputValue;

  constructor(private focusManager: FocusManager) {
    'ngInject';
  }

  // TODO the current implementation works fine with strings only. It will
  // require refactoring to support number input

  /**
   * @param {string} value
   * string value (usually one character) that is being typed in
   * type in a value on the pad
   * @returns {Void}
   * Nothing
   */
  public type(value: string) {
    if (
      angular.isFunction(this.focusManager.getter) &&
      angular.isFunction(this.focusManager.setter)
    ) {
      this.inputValue = this.focusManager.getter();

      if (angular.isUndefined(this.inputValue)) {
        this.inputValue = '';
      }

      this.focusManager.setter(this.inputValue + value);
    }
  }

  /**
   * remove the last character form pad focus
   * @returns {Void}
   * Nothing
   */
  backspace() {
    if (
      angular.isFunction(this.focusManager.getter) &&
      angular.isFunction(this.focusManager.setter)
    ) {
      this.inputValue = this.focusManager.getter();

      if (angular.isUndefined(this.inputValue)) {
        return;
      }

      // TODO for number support casting to string will not be desired
      this.inputValue = this.inputValue.toString();
      this.focusManager.setter(this.inputValue.slice(0, -1));
    }
  }
}
